import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
import {transfersFromCached } from '../../lib/common'
function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.CHECKIN_LIST_API,
    formData
  )

  return handleRequest(request);
}

function checkinUpdateRequestApi(formData) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
  const request = axiosApi().post(
    Constants.CHECKIN_UPDATE_API,
    formData,
    config
  )

  return handleRequest(request);
}

function* checkinListRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, payload)

    // dispatch the action with our widgets!
    yield put(brActions.checkinListSuccess(results.data))

  } catch (error) {
    yield put(brActions.checkinListError(error))
  }
}

function* checkinUpdateRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const result = yield call(checkinUpdateRequestApi, payload)

    // dispatch the action with our widgets!
    if (result.code && result.code != 200) {
      yield put(brActions.checkinUpdateError(result.message))
    } else {
      yield put(brActions.checkinUpdateSuccess(result));
      if (typeof callback == 'function') {
        callback(result);
      }
    }
  } catch (error) {
    yield put(brActions.checkinUpdateError(error))
  }
}
function* checkinReportRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      Constants.CHECKIN_REPORT_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(brActions.checkinReportSuccess(results.data))
  } catch (error) {
    yield put(brActions.checkinReportError(error))
  }
}
function* checkinReportNvkdRequestFlow({ payload }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      Constants.CHECKIN_REPORT_NVKD_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(brActions.checkinReportNvkdSuccess(results.data))
  } catch (error) {
    yield put(brActions.checkinReportNvkdError(error))
  }
}
function* checkinReportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    const url = Constants.CHECKIN_REPORT_EXPORT_XLS_API + "?tuNgay=" + formData.tuNgay + "&denNgay=" + formData.denNgay + "&nhanVien=" + formData.nhanVien
      + "&keyword=" + formData.keyword;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    // grab the client from our action
    const results = yield call(handleFileRequest, request)
    // dispatch the action with our widgets!
    yield put(brActions.checkinReportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(brActions.checkinReportExportXlsError(error))
  }
}
function* checkinKhachHangRequestFlow(action) {
  const { formData, callback } = action
  try {
    const request = axiosApi().post(
      Constants.CHECKIN_KHACHHANG_API,
      formData
    )
    // grab the client from our action
    const results = yield call(handleRequest, request)

    if (results.code && results.code != 200) {
      yield put(brActions.checkinUpdateError(results.message))
    }
    if (typeof callback == 'function') {
      yield call(callback, transfersFromCached(results.data));
    }
  } catch (error) {
    yield put(brActions.checkinUpdateError(error))
  }
}
function* checkinWatcher() {
  yield [
    takeLatest(Constants.CHECKIN_LIST_REQUESTING, checkinListRequestFlow),
    takeLatest(Constants.CHECKIN_UPDATE_REQUESTING, checkinUpdateRequestFlow),
    takeLatest(Constants.CHECKIN_REPORT_REQUESTING, checkinReportRequestFlow),
    takeLatest(Constants.CHECKIN_REPORT_NVKD_REQUESTING, checkinReportNvkdRequestFlow),
    takeLatest(Constants.CHECKIN_REPORT_EXPORT_XLS_REQUESTING, checkinReportExportXlsRequestFlow),
    takeLatest(Constants.CHECKIN_KHACHHANG_REQUESTING, checkinKhachHangRequestFlow),
  ]
}

export default checkinWatcher



// WEBPACK FOOTER //
// ./src/views/Checkin/sagas.js